var map = {
	"./en": 524,
	"./en.js": 524,
	"./ru": 525,
	"./ru.js": 525
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1006;



//////////////////
// WEBPACK FOOTER
// ./src/data/messages ^\.\/.*$
// module id = 1006
// module chunks = 114276838955818